import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import { useUser } from '@/context/userContext';
import { hasRole } from '@/helpers/userHelpers';
import { UserRoleType } from '@/const/user';
import { getAccessDeniedPath } from '../pages/AccessDeniedPage/path/path';

type ProtectedRouteType = {
  allowedRole: UserRoleType[];
};

export const ProtectedRoute = ({ allowedRole }: ProtectedRouteType) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const { user, loading, currentRole, setRole } = useUser();
  const accessDeniedUrl = getAccessDeniedPath();

  useEffect(() => {
    if (!user) return;

    const hasAccess = hasRole(user, allowedRole);

    if (!hasAccess) {
      navigate(accessDeniedUrl, { state: { from: location } });

      return;
    }

    // TODO: check for which case we need this guard
    if (!currentRole || !allowedRole.includes(currentRole)) {
      setRole(allowedRole[0]);
    }

    setChecking(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.pathname]);

  const checkingAccess = loading || !user || checking;

  if (checkingAccess) return;

  if (hasRole(user, allowedRole)) {
    return <Outlet />;
  } else {
    return <Navigate to={accessDeniedUrl} state={{ from: location }} replace />;
  }
};
